import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {App, NavController, PopoverController} from 'ionic-angular';
import {Ce} from '../../shared/models/ce/ce.model';
import {BeneficiaireContextService, CeContextService} from '../../shared/services';
import {OauthService} from "../../shared/services/oauth.service";
import {WebSliderService} from "../../shared/services/webSlider.service";
import {CeService} from "../../shared/services/ce.service";


@Component({
    selector: 'core-header',
    templateUrl: './header.component.html',
})
export class HeaderComponent {

    @Input() titlePage: String;
    @Input() smallTitlePage: String;
    @Input() icon: String;
    @Input() action_icon: String;
    @Input() popover: any;
    @Input() popoverRef: any;
    @Output() action: EventEmitter<any> = new EventEmitter();
    public idBenef: number;
    public firstNameBenef: string;
    public lastNameBenef: string;
    public ce: Ce;

    constructor(
        public navCtrl: NavController,
        private lsService: LocalStorageService,
        private ceContext: CeContextService,

        private ceService: CeService,

        private beneficiaireContext: BeneficiaireContextService,
        private app: App,
        public popoverCtrl: PopoverController,
        public oauthService: OauthService
    ) {
        this.selectCE(this.ceContext.get());

    }

    selectCE(data) {
        this.lsService.setCe(data);
        this.ce = data;
        if (this.ce && this.ce.libelle.length > 35) {
          this.ce.libelle = this.ce.libelle.substring(0,32) + "...";
        }
        this.initHeader();
    }

    initHeader() {
        const beneficiaire = this.beneficiaireContext.get();

        if (null !== beneficiaire) {
            this.idBenef = beneficiaire.id;
            this.firstNameBenef = beneficiaire.prenom;
            this.lastNameBenef = beneficiaire.nom;
        }

    }

    onCLickCart() {
        this.app.getRootNav().setRoot('CartPage');
    }

    onCLickBeneficiaire(id) {
        this.navCtrl.push('BeneficiairePage', {'beneficiaire': id, 'tab': 'benef-card'}); // link to benef page
    }

    presentPopover(myEvent) {
      const popover = this.popoverCtrl.create(this.popover, {ref: this.popoverRef});
      console.log(this.popoverRef);
      popover.present({
        ev: myEvent
      });
    }

    clickAction(myEvent) {
      this.action.emit();
    }

    onLogOut() {
      this.oauthService.logOut(this.app);
    }



}



// WEBPACK FOOTER //
// ./src/core/header/header.component.ts